var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.0457 0 40 8.95438 40 20C40 31.0456 31.0457 40 20 40C20 39.1305 17.3914 20 17.3914 20L20 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 40.0001C8.95474 40.0001 0.000366211 31.0458 0.000366211 20.0001C0.000366211 8.9545 8.95474 0.00012207 20.0004 0.00012207",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2972 16.1637L22.6562 18.425L19.9987 17.5632L21.6423 19.8225L20.0015 22.0839L22.658 21.2189L24.3016 23.4782L24.2999 20.6844L26.9565 19.8194L24.299 18.9577L24.2972 16.1637Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6592 25.6522C18.5376 25.6522 16.007 23.1216 16.007 20C16.007 16.8785 18.5376 14.3478 21.6592 14.3478C22.6325 14.3478 23.5483 14.5939 24.3479 15.0272C23.0935 13.8006 21.3782 13.0435 19.4853 13.0435C15.6433 13.0435 12.5288 16.158 12.5288 19.9999C12.5288 23.8419 15.6433 26.9564 19.4853 26.9564C21.3783 26.9564 23.0936 26.1993 24.3479 24.9727C23.5483 25.4061 22.6325 25.6522 21.6592 25.6522Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgeria);
export default __webpack_public_path__ + "static/media/Algeria.ea5693de620b341f17be3b3409666cc7.svg";
export { ForwardRef as ReactComponent };